export const NUMBER_STYLE_CURRENCY = 'currency';

export const CURRENCY_USD = 'USD';
